import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { cssMap } from '@atlaskit/css';
import { token } from '@atlaskit/tokens';
import { Box } from '@atlaskit/primitives/compiled';

import googleDriveIcon from './img/google-drive.svg';

const ICON_SIZE: Record<'small' | 'large', number> = {
	small: 16,
	large: 28,
};

const i18n = defineMessages({
	googleDriveIconAlt: {
		id: 'space-curation.space-navigation.google-drive-icon.alt',
		defaultMessage: 'Google Drive icon',
		description: 'Alt text for the Google Drive logo displayed next to the third-party auth prompt',
	},
});

const styles = cssMap({
	googleDriveIcon: {
		borderRadius: token('radius.small'),
		flexShrink: 0,
		display: 'inline-flex',
		alignItems: 'center',
		justifyContent: 'center',
		marginInlineStart: '0',
		marginRight: token('space.100'),
		position: 'relative',
		verticalAlign: 'top', //against all odds this centers the icon with the text
		zIndex: 100,
		border: `${token('border.width')} solid ${token('color.border')}`,
	},
});

type GoogleDriveIconProps = {
	variant?: 'small' | 'large';
	testId?: string;
};

export const GoogleDriveIcon = ({
	variant = 'small',
	testId = 'google-drive-icon',
}: GoogleDriveIconProps) => {
	const { formatMessage } = useIntl();
	const size = ICON_SIZE[variant];
	return (
		<Box xcss={styles.googleDriveIcon} testId={testId}>
			<img
				src={googleDriveIcon}
				width={size}
				height={size}
				alt={formatMessage(i18n.googleDriveIconAlt)}
			/>
		</Box>
	);
};
